// fb-eligibility-criteria-admin.component.ts
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  EcaseHttpService,
  ECaseSnackBarService, ECaseUtils, EligibilityService,
  LoginAuthenticationService,
  PendingChangesGuard,
  RefreshDataService
} from 'synto-common';
import { MatDialog } from '@angular/material/dialog';
import {DialogComponent} from "../dialog/dialog.component";
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'fb-eligibility-criteria',
  templateUrl: './fb-eligibility-criteria.component.html',
  styleUrls: ['./fb-eligibility-criteria.component.scss']
})
export class FbEligibilityCriteriaComponent implements OnInit {
  @Input() globalPrj: any;
  @Input() selectedLanguage: any;
  @Input() selectedSectionId: any;
  @Input() isValidHtml: boolean;
  @Input() isValidTable: boolean;
  @Input() isValidTableReadonly: boolean;
  @Input() isFormbuilderModeEnabled: boolean;
  @Input() bphChange: any;
  @Input() confChange: any;
  @Input() globalConf: any;
  @Input() offlineModeEnabled;
  @Input() blockIndex: number;
  @Input() sections;
  @Output() emitOutputEvent = new EventEmitter<any>();
  containerConfChange: any;
  showFilteredImage = true;
  beforeFilteringRows = [];
  pageSizeOptions = [5, 10, 25, 100];
  pageSize = 10;
  pageIndex = 0;
  eligibilityCategories: any[] = [];
  eligibilities: any[] = [];
  eligibilityForm: FormGroup = new FormGroup({});


  constructor(
    private fb: FormBuilder,
    private eCaseHttpService: EcaseHttpService,
    private eCaseSnackBarService: ECaseSnackBarService,
    private loginAuthenticationService: LoginAuthenticationService,
    private refreshDataService: RefreshDataService,
    private translate: TranslateService,
    private matDialog: MatDialog,
    private pendingChangesGuard: PendingChangesGuard,
    private eligibilityService: EligibilityService,

  ) {}

  ngOnInit(): void {
    this.eligibilityForm = new FormGroup({});
    this.initEligibilityCategories();

  }

  initEligibilityCategories(): void {
    const requestPayload = {
      competitionId: this.globalPrj.cpmCompetitionID,
      selectedCategoryCriteria: this.confChange.selectedCriteriaCategories
    };

    this.eligibilityService.getListOfCriteriasForSelectedCompetition(requestPayload)
      .subscribe((result: any[]) => {
        this.eligibilityCategories = result || [];
        this.bphChange.value = this.bphChange.value || [];

        for (const category of this.eligibilityCategories) {
          let savedCategory = this.bphChange.value.find(c => c.id === category.id);
          if (!savedCategory) {
            savedCategory = {
              id: category.id,
              name: category.name,
              criterias: []
            };
            this.bphChange.value.push(savedCategory);
          }

          savedCategory.criterias = savedCategory.criterias || [];

          for (const criterion of category.criteria) {
            let savedCriterion = savedCategory.criterias.find(sc => sc.id === criterion.id);
            if (!savedCriterion) {
              savedCategory.criterias.push({
                ...criterion,
                value: null
              });
            }

            const controlId = criterion.id;
            if (!this.eligibilityForm.contains(controlId)) {
              const existingValue = this.getCriterionValue(category.id, criterion.id);
              this.eligibilityForm.addControl(controlId, new FormControl(existingValue));
            }
          }
        }

        console.log('[EligibilityCategories] structure:', this.eligibilityCategories);
        console.log('[bphChange.value] initialized with null values:', this.bphChange.value);
      });
  }




  getCriterionValue(categoryId: number, criterionId: number): boolean | undefined {
    const categories = Array.isArray(this.bphChange?.value)
        ? this.bphChange.value
        : [];

    const category = categories.find(cat => cat.id === categoryId);

    const criterias = Array.isArray(category?.criterias)
        ? category.criterias
        : [];

    const criterion = criterias.find(c => c.id === criterionId);

    return criterion?.value;
  }

  changeValueEvent(event: any, categoryId: number, criterion: any): void {
    const value = event.value;

    this.bphChange.value = this.bphChange.value || [];
    this.bphChange.value = Array.isArray(this.bphChange.value) ? this.bphChange.value : [];

    let category = this.bphChange.value.find(cat => cat.id === categoryId);
    if (!category) {
      const eligibilityCategory = this.eligibilityCategories.find(c => c.id === categoryId);
      category = {
        id: categoryId,
        name: eligibilityCategory?.name,
        criterias: []
      };
      this.bphChange.value.push(category);
    }

    const existing = category.criterias.find(c => c.id === criterion.id);
    if (existing) {
      existing.value = value;
    } else {
      category.criterias.push({ ...criterion, value });
    }


    if (this.confChange && this.confChange.executeOnChange) {
      this.confChange.executeOnChange(this.globalConf, this.globalPrj, this.selectedLanguage, value);
    }

    this.refreshDataService.setNewValueForStaticText(this.confChange.name, this.bphChange.value);
    this.pendingChangesGuard.isPristine = false;


    this.emitOutputEvent.emit({
      event,
      bphChange: this.bphChange,
      confChange: this.confChange,
      prj: this.globalPrj,
      conf: this.globalConf,
      refreshDataService: this.refreshDataService
    });

  }


  openDialog(confChange) {
    this.matDialog.open(DialogComponent, {
      width: '600px',
      data: {dialog: confChange.dialogText, selectedLanguage: this.selectedLanguage}
    });
    console.log('donee');
  }


  getTranslatedValue(key): string {
    return ECaseUtils.getTranslatedValueFromKey(this.translate, key, this.selectedLanguage);
  }







}
